import type { Computable, Measurement } from '@klareospace/pharos-lib-types';

/** The result of formatting a Computable<Measurement>. */
export type FormattedMeasurement = {
  isComputed: boolean;
  text: string;
};

/**
 * Format a Computable<Measurement> to a `FormattedMeasurement` tuple.
 * Returns null when the measurement is undefined.
 *
 * `text` is formatted as `"<value> <resolved unit label>"` (e.g. `"5.2 kg"`). `resolveUnitLabel`
 * is required so callers never leak the raw unit enum (e.g. `m3`) to the UI.
 */
export function formatMeasurement(
  measurement: Computable<Measurement<string>> | undefined,
  resolveUnitLabel: (unit: string) => string,
): FormattedMeasurement | null {
  if (!measurement) return null;
  return {
    isComputed: measurement.isComputed,
    text: `${measurement.data.value} ${resolveUnitLabel(measurement.data.unit)}`,
  };
}
